import { loadingAnimation } from 'components/Loader/styled'
import styled from 'styled-components/macro'

/* Loading state bubbles (animation style from: src/components/Loader/styled.tsx) */
export const LoadingBubble = styled.div<{
  height?: string
  width?: string
  round?: boolean
  delay?: string
  margin?: string
}>`
  border-radius: 12px;
  border-radius: ${({ round }) => (round ? '50%' : '12px')};
  ${({ margin }) => margin && `margin: ${margin}`};
  height: ${({ height }) => height ?? '24px'};
  width: 50%;
  width: ${({ width }) => width ?? '50%'};
  animation: ${loadingAnimation} 1.5s infinite;
  ${({ delay }) => delay && `animation-delay: ${delay};`}
  animation-fill-mode: both;

  background: linear-gradient(
    to left,
    ${({ theme }) => theme.backgroundOutline} 25%,
    ${({ theme }) => theme.backgroundInteractive} 50%,
    ${({ theme }) => theme.backgroundOutline} 75%
  );
  background-size: 200% 100%;
  background-position-x: 180%;
  will-change: background-position;
`
export const SmallLoadingBubble = styled(LoadingBubble)<{
  width?: string
}>`
  width: ${({ width }) => width ?? '25%'};
`

export const MediumLoadingBubble = styled(LoadingBubble)<{
  width?: string
}>`
  width: ${({ width }) => width ?? '65%'};
`

export const LongLoadingBubble = styled(LoadingBubble)<{
  width?: string
}>`
  width: ${({ width }) => width ?? '90%'};
`

export const IconLoadingBubble = styled(LoadingBubble)<{
  width?: string
  height?: string
}>`
  border-radius: 50%;
  width: ${({ width }) => width ?? '24px'};
  height: ${({ height }) => height ?? '24px'};
`

export const LoadingDataBubble = styled(LoadingBubble)`
  width: 32px;
  height: 16px;
`
